import { fetchUserClient } from '@/api/task-project.js'
import { RoomListApi } from '@/api/room'

export const CourseBuilder = {
  created () {
    this.fetchroomList()
    this.getTeacherList()
  },
  data () {
    return {
      observerTeacher: new IntersectionObserver(this.loadMoreTeacher),
      observerRoom: new IntersectionObserver(this.loadMoreRooms),
      teacher_meta: {
        page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      room_meta: {
        current_page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      roomList: [],
      teacherList: [],
      customer_id: localStorage.getItem('customer_id')
    }
  },
  methods: {
    async fetchroomList () {
      try {
        const payload = {}
        payload.limit = 2
        const responseList = await RoomListApi(
          this.customer_id,
          'Room',
          this.room_meta,
          payload
        )
        this.roomList = responseList.data.data.assets_list
        this.room_meta = responseList.data.data.meta
      } catch (error) {}
    },
    async onOpenRoom () {
      if (this.room_meta.has_next) {
        await this.$nextTick()
        this.observerRoom.observe(this.$refs.loadRooms)
      }
    },
    onCloseRoom () {
      this.observerRoom.disconnect()
    },
    async loadMoreRooms ([{ isIntersecting, target }]) {
      if (isIntersecting) {
        const ul = target.offsetParent
        const scrollTop = target.offsetParent.scrollTop

        try {
          const payload = {}
          payload.limit = 2
          this.room_meta.current_page = this.room_meta.current_page + 1
          const responseList = await RoomListApi(
            this.customer_id,
            'Room',
            this.room_meta,
            payload
          )
          this.roomList.push(...responseList.data.data.assets_list)
          this.room_meta = responseList.data.data.meta
        } catch (e) {}
        await this.$nextTick()
        ul.scrollTop = scrollTop
      }
    },
    async fuseSearch (search) {
      try {
        const payload = {
          name: search
        }

        this.teacher_meta.page = 1
        const { data } = await fetchUserClient(
          'User',
          this.customer_id,
          this.teacher_meta,
          payload
        )
        this.teacherList = data.data.users_list
        this.teacher_meta = data.data.meta
        this.teacher_meta.page = data.data.meta.current_page
 
      } catch (e) {}
    },
    async loadMoreTeacher ([{ isIntersecting, target }]) {
      if (isIntersecting) {
        const ul = target.offsetParent
        const scrollTop = target.offsetParent.scrollTop

        try {
          this.teacher_meta.page = this.teacher_meta.page + 1
          const { data } = await fetchUserClient(
            'User',
            this.customer_id,
            this.teacher_meta
          )
          this.teacherList.push(...data.data.users_list)
          this.teacher_meta = data.data.meta
          this.teacher_meta.page = data.data.meta.current_page
        } catch (e) {}
        await this.$nextTick()
        ul.scrollTop = scrollTop
      }
    },
    async onOpenTeacher () {
      if (this.teacher_meta.has_next) {
        await this.$nextTick()
        console.log(this.$refs.loadTeacher)
        this.observerTeacher.observe(this.$refs.loadTeacher)
      }
    },
    onCloseTeacher () {
      this.observerTeacher.disconnect()
    },
    async getTeacherList () {
      try {
        const { data } = await fetchUserClient(
          'User',
          this.customer_id,
          this.teacher_meta
        )
        this.teacherList = data.data.users_list
        this.teacher_meta = data.data.meta
        console.log(this.teacher_meta)
        this.teacher_meta.page = data.data.meta.current_page
      } catch (e) {}
    }
  }
}
